export default {
      id: "font-p-usage",
      viewBox: "0 0 480 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#font-p",
      toString: function () {
        return this.url;
      }
    }